import styled from "styled-components";

export const ModeIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ModeIconCircle = styled.button`
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;

  width: ${({ theme }) => theme.iconSize.lg};
  height: ${({ theme }) => theme.iconSize.lg};
  border-radius: ${({ theme }) => theme.br.circle};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, $active, $mobile }) =>
    $active || $mobile ? theme.primary : "transparent"};
  color: ${({ theme, $active, $mobile }) =>
    $active || $mobile ? theme.textLight : theme.textMedium};
  transition: background-color 0.18s ease, color 0.18s ease;

  ${ModeIconWrapper}:hover & {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.textLight};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: ${({ theme }) => theme.iconSize.xl};
    height: ${({ theme }) => theme.iconSize.xl};
  }
`;

export const ModeMenu = styled.div`
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.spacing[2]});
  left: 50%;
  transform: translateX(-50%);
  background: ${({ theme }) => theme.backgroundLight};
  border-radius: 50%;
  padding: ${({ theme }) => theme.spacing[1]};
  box-shadow: ${({ theme }) => theme.dropdownMenu.boxShadow};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
  animation: modeMenuIn 0.18s ${({ theme }) => theme.easing.entering};

  @keyframes modeMenuIn {
    from {
      opacity: 0;
      transform: translate(-50%, -4px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
`;

export const ModeMenuItem = styled.button`
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;

  width: ${({ theme }) => theme.iconSize.lg};
  height: ${({ theme }) => theme.iconSize.lg};
  border-radius: ${({ theme }) => theme.br.circle};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.backgroundLight};
  color: ${({ theme }) => theme.textMedium};
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover,
  &:focus-visible {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.textLight};
    outline: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: ${({ theme }) => theme.iconSize.xl};
    height: ${({ theme }) => theme.iconSize.xl};
  }
`;
